import ReactDOM from 'react-dom/server'
import React from 'react'

import Typography from '../../packages/typography/src/'
import { GoogleFont } from '../../packages/react-typography/src/'
import CodePlugin from '../../packages/typography-plugin-code'
import designTools from '../../packages/typography-design-tools/src/'

const theme = {}
theme.plugins = [
  new CodePlugin(),
]

const typography = new Typography(theme)

designTools(typography)

// Hot reload typography in development.
if (process.env.NODE_ENV !== 'production') {
  typography.injectStyles()
  if (typeof document !== 'undefined') {
    const googleFonts = ReactDOM.renderToStaticMarkup(
      React.createFactory(GoogleFont)({ typography })
    )
    const head = document.getElementsByTagName('head')[0]
    head.insertAdjacentHTML('beforeend', googleFonts)
  }
}

export default typography



/** WEBPACK FOOTER **
 ** ../utils/typography.js
 **/